import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { FlowManager } from '../../flow-management/FlowManager';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { Step } from '../../views/Step';
export const BranchManagementLevelACQ130 = {
  name: 'BranchManagementLevelACQ130',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ130, [ExperimentParameterGroup.Variant_A, ExperimentParameterGroup.Variant_B]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const flowSteps = getFlowSteps();
    const postVerification = FlowManager.replaceStep(Step.JobRole, Step.ManagementLevel)(flowSteps.postVerification);
    const newFlowSteps = [...flowSteps.preVerification, ...postVerification, ...flowSteps.postAccountCreation, ...flowSteps.postExistingAccountSelection];
    dispatch(setFlow(newFlowSteps, flowSteps.preVerification, postVerification, flowSteps.postAccountCreation, flowSteps.postExistingAccountSelection));
    return newFlowSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};